/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TimeBasedChart_timeBased = {|
  +jobRequests: ?{| |};
  +jobOffers: ?{| |};
  +jobs: ?{| |};
  +students: ?{| |};
  +tutors: ?{| |};
  +expiredJobRequestsWithNoOffers: ?{| |};
  +expiredJobRequestsWithOffers: ?{| |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TimeBasedChart_timeBased",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "jobRequests",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "jobOffers",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "jobs",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "students",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "tutors",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "expiredJobRequestsWithNoOffers",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "MetricTimePeriod",
      "name": "expiredJobRequestsWithOffers",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TimeBasedChartFragment",
          "args": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimeBasedMetric"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/components/home/__generated__/TimeBasedChart_timeBased.graphql.js